import EfCheckInActivities2 from '@elem/ui/ef-check-in-activities2';
import { Fragment } from 'react';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { pageUrl } = data;
    return (
        <Fragment>
            {pageUrl && (
                <div id={id} className="GtmModuleData-section" data-section-id={'Member-CheckIn2'} data-section-title={'Member-CheckIn2'}>
                    <EfCheckInActivities2 pageUrl={pageUrl} data={data} />
                </div>
            )}
        </Fragment>
    );
}
